import React from 'react';
import styled, { withTheme } from 'styled-components';

const MediaWrapper = styled.span`
  display: inherit;

  ${props =>
    props.breakpoint &&
    props.theme.media[props.breakpoint].max`
    display: none !important;
  `}
`;

export const Conditional = ({
  show,
  theme,
  children,
  breakpoint
}) => {
  if (!breakpoint && !show) {
    return null;
  }

  return (
    <MediaWrapper breakpoint={breakpoint}>
      {children}
    </MediaWrapper>
  );
};

export default withTheme(Conditional);

